export const DEMO_UPDATE_SCORE = 'DEMO_UPDATE_SCORE';
export const DEMO_UPDATE_NAME = 'DEMO_UPDATE_NAME';
export const DEMO_UPDATE_TAG = 'DEMO_UPDATE_TAG';
export const DEMO_SAVE = 'DEMO_SAVE';
export const DEMO_SAVE_SUCCESS = 'DEMO_SAVE_SUCCESS';
export const DEMO_SAVE_FAIL = 'DEMO_SAVE_FAIL';
export const DEMO_RESET = 'DEMO_RESET';
